/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path context
 * @description Provider for the Scroll context
 */
import React from "react";
import createContext from "zustand/context";
import { createStore, ScrollPositionStore } from "./ScrollCtx";
const { Provider, useStore } = createContext<ScrollPositionStore>();
export const ScrollCtxProvider: React.FC<{
  children: React.ReactNode;
}> = (props: { children: React.ReactNode }) => {
  return <Provider createStore={createStore}>{props?.children}</Provider>;
};
export const useScrollContext = useStore;
